import { render } from "./JourneyIdContainer.vue?vue&type=template&id=ca4fca80&scoped=true&lang=html"
import script from "./JourneyIdContainer.vue?vue&type=script&lang=js"
export * from "./JourneyIdContainer.vue?vue&type=script&lang=js"

import "./JourneyIdContainer.vue?vue&type=style&index=0&id=ca4fca80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4fca80"]])

export default __exports__